import * as React from "react";
import {
  FormatAlignCenterRounded,
  FormatAlignJustifyRounded,
  FormatAlignLeftRounded,
  FormatAlignRightRounded,
} from "@mui/icons-material";
import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { ELEMENTS_GUI_FIELDS } from "./elements.settings";

const {
  "Bordures & Arrondis": br,
  "Thème & Couleurs": THEME,
  ...rest
} = ELEMENTS_GUI_FIELDS;

export const X_RATING_GUI_FIELDS: TXGUISection = {
  Général: [
    {
      type: "toggle_option",
      name: "editable",
      label: "Modifiable",
      options: [
        { value: false, label: "Non" },
        { value: true, label: "Oui" },
      ],
      defaultValue: false,
    },
    {
      type: "toggle_option",
      name: "reviewCountMode",
      label: "Compte",
      options: [
        { value: "none", label: "Aucun" },
        { value: "number", label: "Nombre" },
        { value: "full", label: "Texte" },
      ],
      defaultValue: "none",
    },
  ],
  "Thème & Couleurs": [
    {
      type: "color",
      name: "color",
      label: "Couleur du texte",
      defaultValue: "#000000",
    },
    // {
    //   type: "font",
    //   name: "fontFamily",
    //   label: "Police",
    //   defaultValue: "inherit",
    // },
    {
      type: "select_option",
      name: "fontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 400,
    },

    {
      type: "toggle_option",
      name: "textAlign",
      label: "Alignement du texte",
      options: [
        { value: "left", label: "Gauche", icon: <FormatAlignLeftRounded /> },
        {
          value: "center",
          label: "Centre",
          icon: <FormatAlignCenterRounded />,
        },
        { value: "right", label: "Droite", icon: <FormatAlignRightRounded /> },
        {
          value: "justify",
          label: "Remplir",
          icon: <FormatAlignJustifyRounded />,
        },
      ],
      defaultValue: "left",
    },
    {
      type: "sizing",
      name: "fontSize",
      label: "Taille de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt"],
    },
  ],
  ...rest,
};
